import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { DocumentInfo } from '../models/document-verification.model';
import { ErrorResponse } from '../models/error-response.model';
import { UtilsService } from './utils.service';

@Injectable({
	providedIn: 'root',
})
export class CustomerDocumentsApiService {
	constructor(
		private httpClient: HttpClient,
		private utilsService: UtilsService
	) {}

	/**
	 * Get document information by document ID
	 * @param documentId - The document ID
	 */
	getDocumentInformation$(documentId: string): Observable<DocumentInfo> {
		return this.httpClient.get<DocumentInfo>(this.getInformationPath(documentId)).pipe(
			catchError((response: HttpErrorResponse) => {
				return throwError(this.utilsService.buildErrorModel(response));
			})
		);
	}

	/**
	 * Create new document information
	 * @param documentId - The document ID
	 * @param data - The verification data to save
	 */
	createDocumentInformation$(documentId: string, data: DocumentInfo): Observable<void | ErrorResponse> {
		return this.httpClient.post<void>(this.getInformationPath(documentId), data).pipe(
			catchError((response: HttpErrorResponse) => {
				return throwError(this.utilsService.buildErrorModel(response));
			})
		);
	}

	updateDocumentInformation$(documentId: string, data: DocumentInfo): Observable<void | ErrorResponse> {
		return this.httpClient.put<void>(this.getInformationPath(documentId), data).pipe(
			catchError((response: HttpErrorResponse) => {
				return throwError(this.utilsService.buildErrorModel(response));
			})
		);
	}

	documentNumberExists$(documentNumber: string): Observable<boolean> {
		return this.httpClient.get<boolean>(this.documentExistsPath(), {
			params: {
				DocumentNumber: documentNumber,
			},
		});
	}

	private getBasePath(): string {
		return `${environment.apiUrl}/CustomerDocuments`;
	}

	private getInformationPath(documentId: string): string {
		return `${this.getBasePath()}/information/${documentId}`;
	}

	private documentExistsPath(): string {
		return `${this.getBasePath()}/exists`;
	}
}
